/* eslint-disable react/jsx-no-target-blank */
import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import Data from '../../../assets/images/Data.png';
import Charts from '../../../assets/images/Charts.png';
import styles from '../homePageStyles';
import uoapic from '../../../assets/images/Shark.png'

const RightSidebar = () => {
  /** @type {import('../../../typings').IStateReducerState}*/
  const { isMobile } = useSelector((state) => state.appReducer);

  return (
    <Grid item xs={12} sm={12} md={3} lg={3} style={{ height: '100%' }}>
      <div
        style={{
          ...styles.rightSideMainDiv,
          marginTop: isMobile ? '30px' : '0px',
        }}
      >
        <a
          href="https://optionsgeek.com/3-steps-to-profit-members-area/the-ultimate-guide-to-unusual-options-activity/"
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <div style={styles.imageDiv}>
            <img src={uoapic} height="100%" width="100%" alt="test" />
            {/* <img style={styles.imageStyle} src={Shark}></img> */}
          </div>
        </a>

        <a
          href="https://marketchameleon.com/?pap_aid=Felix"
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <div style={{ ...styles.imageDiv, padding: '10px' }}>
            <img src={Data} width="100%" height="100%" alt="test" />
          </div>
        </a>
        <a
          href="https://www.tradingview.com/?offer_id=10&aff_id=13279"
          // target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <div style={styles.imageDiv}>
            <img
              // style={styles.imageStyle}
              height="100%"
              width="100%"
              src={Charts}
              alt="test"
            />
          </div>
        </a>
      </div>
    </Grid>
  );
};

export default RightSidebar;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/RightSidebar/index.jsx